<template>
  <breadCrumbs title="Time Picker" main="Form Wizards" title1="Time Picker" />
  <div class="container-fluid">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Date Time Picker</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="datetime-picker">
              <form class="theme-form">
                <usingLocales />
                <timeOnly />
                <dateOnly />
                <div class="mb-3 row g-3">
                  <label class="col-sm-3 col-form-label text-end">No Icon (input field only)</label>
                  <div class="col-xl-5 col-sm-7 col-lg-8">
                    <input class="form-control datetimepicker-input digits" id="dt-noicon" type="text"
                      data-toggle="datetimepicker" data-target="#dt-noicon">
                  </div>
                </div>
                <disableDate />
                <viewMode />
                <disableDay />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { ref, computed } from 'vue';
import usingLocales from "./usingLocales.vue"
import timeOnly from "./timeOnly.vue"
import dateOnly from "./dateOnly.vue"
import disableDate from "./disableDate.vue"
import viewMode from "./viewMode.vue"
import disableDay from "./disableDay.vue"
export default {
  components: {
    usingLocales, timeOnly, dateOnly, disableDate, viewMode, disableDay
  },
  data() {
    return {
    }
  },
  setup() {
    const date2 = ref();
    const time = ref({
      hours: new Date().getHours(),
      minutes: new Date().getMinutes()
    });
    const date = ref();

    const format = (date) => {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return ` ${day}/${month}/${year}`;
    }
    const date1 = ref(new Date());
    const date3 = ref(new Date());
    const date4 = ref();

    const disabledDates = computed(() => {
      const today = new Date();

      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)

      const afterTomorrow = new Date(tomorrow);
      afterTomorrow.setDate(tomorrow.getDate() + 1);

      return [tomorrow, afterTomorrow]
    })
    return {
      date2, time, date,
      format, disabledDates,
      date1, date3, date4
    }
  }
}
</script>